import CollectionsByPayer from './CollectionsByPayer';

export default CollectionsByPayer;
